import styled from 'styled-components';
import { Dialog } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import { orange } from '@material-ui/core/colors';

export const styles = {
  cardAction: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px',
    justifyContent: 'center',
  },
  filesContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '10px',
    padding: '5px',
    border: '1px solid #ff9800',
    borderRadius: '10px',
    width: 'fit-content',
  },
  fileName: {
    fontSize: '12px',
    fontWeight: 'bold',
    fontFamily: 'Nunito',
  },
  textfield: {
    marginBottom: '15px',
  },
  icon: {
    padding: '0px',
  },
};

export const Button = styled.button`
  width: 150px;
  transition: all 0.5s ease-in-out;
  background-color: #FFA500;
  border: none;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  font-family: 'Nunito', sans-serif;
  height: 50px;
  letter-spacing: 1px;
  margin: 0 ;
  &:hover {
    background-color: #FFA555;
    border-color: #fff;
  }
}
`;
export const Form = styled(Dialog)`
  // & .MuiPaper-root {
  //   height: 50%;
  // }
`;

export const theme = createTheme({
  palette: {
    primary: orange,
  },
});
